import { ReactNode, ReactElement, useCallback } from 'react';
import styles from './ui-external-link-button.module.scss';
import { blue, charcoal, red } from '../../styles';
import { UIIcon, UIIconName } from '../ui-icon';

type UIExternalLinkButtonVariant =
    | 'default'
    | 'textDefault'
    | 'primary'
    | 'textPrimary'
    | 'danger'
    | 'textDanger';

export type UIExternalLinkButtonProps = {
    children?: ReactNode;
    href?: string;
    newtab?: boolean;
    size?: 'small' | 'normal';
    variant?: UIExternalLinkButtonVariant;
    customHeight?: number;
    text?: string;
    leftIcon?: UIIconName;
};
export function UIExternalLinkButton(
    props: UIExternalLinkButtonProps
): ReactElement {
    const {
        children,
        href,
        newtab = true,
        size = 'normal',
        variant = 'default',
        customHeight,
        text,
        leftIcon
    } = props;

    // Variant has a corresponding classname
    const buttonClasses = [styles.button, styles[size], styles[variant]];

    if (!variant.includes('text')) {
        buttonClasses.push(styles[`${size}Padding`]);
    } else {
        buttonClasses.push(styles.noPadding);
    }

    const leftIconComponent = useCallback(() => {
        function getSize(): number {
            switch (size) {
                case 'small':
                    return 12;
                case 'normal':
                    return 16;
            }
        }

        if (leftIcon) {
            return (
                <UIIcon
                    name={leftIcon}
                    color={getColor(variant)}
                    size={getSize()}
                />
            );
        } else {
            return undefined;
        }
    }, [leftIcon, size, variant]);

    return (
        <a
            className={buttonClasses.join(' ')}
            href={href}
            target={newtab ? '_blank' : undefined}
            style={{
                height: customHeight
            }}
        >
            {leftIconComponent()}
            {text}
            {children}
        </a>
    );
}

function getColor(variant: string): string {
    switch (variant) {
        case 'default':
        case 'textDefault':
            return charcoal;
        case 'primary':
        case 'danger':
            return 'white';
        case 'textPrimary':
            return blue;
        case 'textDanger':
            return red;
    }
    return charcoal;
}
